import { useFicha } from "../../-utils/ficha";

import { DoneScreen } from "./done-screen";
import { FormStep } from "./form-step";
import { ResumeScreen } from "./resume-screen";
import { SendScreen } from "./send-screen";
import { WelcomeScreen } from "./welcome-screen";

export function Ficha() {
	const ficha = useFicha();
	const { phase, draft, accept, hp, pending, actions } = ficha;

	if (phase === "resume") {
		return <ResumeScreen onResume={actions.goToForm} onRestart={actions.restart} />;
	}

	if (phase === "welcome") {
		return <WelcomeScreen onStart={actions.goToForm} />;
	}

	if (phase === "done") {
		return <DoneScreen draft={draft} />;
	}

	if (phase === "send") {
		return (
			<SendScreen
				accept={accept}
				onAcceptChange={actions.setAccept}
				hp={hp}
				onHpChange={actions.setHp}
				onBack={actions.goToForm}
				onSubmit={actions.submit}
				pending={pending}
			/>
		);
	}

	return <FormStep ficha={ficha} />;
}
